import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import InputUI from '../../../components/UI/InputUI';
import { translate, convertToSeparator, isNullOrEmpty, showMessageToastCustom, autoFocus, enumText } from '../../../utils/util';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import BackButton from '../../../components/UI/BackButton';
import ScannerCode from '../../../components/UI/ScannerCode';
import SecurityService from '../../../services/SecurityService';
import useStateWithPromise from '../../../utils/useEffectUpdate';
import ModalBottomSheetUI from '../../../components/UI/ModalBottomSheetUI';
import { ENUMS } from '../../../utils/constants';

const SearchPartNumber = (props) => {
    const [data, setData] = useState([]);
    const [filter, setFilter] = useStateWithPromise({
        qrCode: props.filter?.partNumber || "",
        partNumber: props.filter?.partNumber || "",
        invoiceLabel: '',
        notFinished: true,
        pending: true
    });
    const [info, setInfo] = useState({ data: {}, open: true });

    useEffect(() => {
        autoFocus("txtPartNumber");
        if (!isNullOrEmpty(filter.partNumber)) {
            onClickButton();
        }
        // eslint-disable-next-line
    }, []);

    const onChangeLabel = (value) => {
        if (!isNullOrEmpty(value)) {
            if (value.length >= 55) {
                filter.qrCode = value;
                filter.partNumber = value.substring(0, 11);
                filter.invoiceLabel = value.substring(55, 64);
                return setFilter({ ...filter }).then(() => {
                    onClickButton()
                });
            } else if (value.length === 11) {
                filter.qrCode = value;
                filter.partNumber = value;
                filter.invoiceLabel = ''
                return setFilter({ ...filter }).then(() => {
                    onClickButton()
                });
            }
        }

        filter.qrCode = value;
        filter.invoiceLabel = ''
        setFilter({ ...filter });
    }

    const handleOnKeyDown = (event) => {
        if (event.key === 'Enter') {
            onChangeLabel(event.target.value);
        }
    }

    const onClickButton = () => {
        props.getPartNumbers(filter, (response) => {
            props.setFilter({ ...props.filter, partNumber: filter.partNumber })
            if (!response || response.length === 0) {
                filter.qrCode = "";
                setFilter({ ...filter });
                return showMessageToastCustom(translate('general:warning'),
                    translate('item-not-found', 'validations'),
                    4000, 'mdi mdi-alert-circle-outline red-text')
            }
            setData(response)
        });
    }

    const renderItem = (item, index) => {
        return (
            <div key={index} 
                onClick={() => {
                    info.open = info.open ? false : true;
                    setInfo({ ...info, data: item })}}
                >
                <span
                    key={`${item.id}-span`}
                    className="title sixth-text-color right"
                    style={{ position: 'absolute', marginTop: '10px', right: '5px', zIndex: '999', cursor: 'pointer' }}  
                >
                </span>
                <li
                    id={`${item.id}-li`}
                    className="collection-item"
                    style={{ backgroundColor: 'white', color: 'black' }}
                >
                    <div id={`${item.id}-div`}>
                        <div id={`${item.id}-row`} className="row" style={{ marginBottom: '0px', wordWrap: 'break-word' }}>
                            <div className="title black-text col s12" style={{ padding: '0px' }}>{item.partNumberCode}</div>
                            <div className="col s12 second-text-color" style={{ padding: '0px' }}>{item.partNumberDescription}</div>
                            <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:mvm')}: ${item.physicalConfirmation.mvmNumber}`}</small>
                            <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:qme')}: ${convertToSeparator(item.qme) || 0}`}</small>
                            <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('available', 'general')}: ${convertToSeparator(item.balance) || 0}`}</small>
                            <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:mdr')}: ${item.mdr || ''}`}</small>
                            <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:qt-receipt')}: ${item.accoutingQuantity - item.balance || 0}`}</small>
                            <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:note')}: ${item.invoice || ''}`}</small>
                            <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:shed')}: ${item.physicalConfirmationShed?.shed || ""}`} </small>
                            <small className="col s4 m3 second-text-color" style={{ padding: '0px' }}>{`${translate('physical-confirmation:area')}: ${item.almox || ""}`} </small>
                        </div>
                    </div>
                </li>
            </div>
        )
    }

    const closeModal = () => {
        info.open = false;
        setInfo({ ...info });
    }

    const getStatus = (value) =>  translate(enumText(ENUMS.eReceiptStatus, value), 'physical-confirmation')

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65" />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '3px', paddingTop: '10px' }}>
                        <div className="input-field no-padding col s12">
                            <ScannerCode onScanner={onChangeLabel} className="mdi mdi-barcode-scan posfix disable" />
                            <InputUI
                                autoFocus
                                required
                                label={translate('scanner-receipt.partnumber')}
                                id="txtPartNumber"
                                type="text"
                                onChange={(e) => onChangeLabel(e.target.value)}
                                onKeyDown={(e) => handleOnKeyDown(e)}
                                value={filter.qrCode}
                            />
                        </div>
                    </div>
                </div> 
                <ModalBottomSheetUI
                    open={info.open}
                    maxHeight="80%" 
                    onClose={closeModal} 
                    data={
                        <form>
                            <div className="row" style={{ marginBottom: '0' }}> 
                                <div className="title black-text col s12" style={{ padding: 0 }}> {info.data?.partNumberCode}</div>
                                <div className="row" style={{ marginBottom: '0' }}> 
                                    <div className="input-field no-padding col s12">
                                        <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}> {translate('stock:description')}</span>
                                        <span className="field f-1r truncate sixth-text-color">{info.data?.partNumberDescription}</span> 
                                    </div> 
                                </div>
                                <div className="row" style={{ marginBottom: '0' }}>
                                    <div className="input-field no-padding col s6 m3">
                                        <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:qt-invoice')}</span>
                                        <span className="field f-1r truncate sixth-text-color">{info.data?.accoutingQuantity}</span>  
                                    </div>
                                    <div className="input-field no-padding col s5 m3">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:qt-identify')}</span>
                                        <span className="field f-1r truncate sixth-text-color">{info.data?.accoutingQuantity - info.data?.balance}</span> 
                                    </div> 
                                </div>
                                <div className="row" style={{ marginBottom: '0' }}>
                                    <div className="input-field no-padding col s6 m3">
                                        <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:bai-code')}</span>
                                        <span className="field f-1r truncate sixth-text-color">{info.data?.baiCode || '-'}</span> 
                                    </div>
                                    <div className="input-field no-padding col s5 m3">
                                        <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:container-number')}</span>
                                        <span className="field f-1r truncate sixth-text-color">{info.data?.container || '-'}</span> 
                                    </div> 
                                </div>
                                <div className="row" style={{ marginBottom: '0' }}>
                                    <div className="input-field no-padding col s6 m3">
                                        <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:invoice')}</span>
                                        <span className="field f-1r truncate sixth-text-color">{info.data?.invoice}</span> 
                                    </div>
                                    <div className="input-field no-padding col s5 m3">
                                        <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:invoice-line')}</span>
                                        <span className="field f-1r truncate sixth-text-color">{info.data?.invoiceLine}</span> 
                                    </div> 
                                </div>
                                <div className="row" style={{ marginBottom: '0' }}>
                                    <div className="input-field no-padding col s12">
                                        <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('general:status')}</span>
                                        <span className="field f-1r truncate sixth-text-color">{getStatus(info.data?.status)}</span> 
                                    </div> 
                                </div>
                                <div className="row" style={{ marginBottom: '0' }}>
                                    <div className="input-field no-padding col s6 m3">
                                        <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:shed')}</span>
                                        <span className="field f-1r truncate sixth-text-color">{info.data?.shed}</span> 
                                    </div>
                                    <div className="input-field no-padding col s5 m3">
                                        <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:almox')}</span>
                                        <span className="field f-1r truncate sixth-text-color">{info.data?.almox ? info.data?.almox : '-'}</span> 
                                    </div> 
                                </div>
                                <div className="row" style={{ marginBottom: '0' }}>
                                    <div className="input-field no-padding col s6 m3">
                                        <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:hot-request')}</span>
                                        <span className="field f-1r truncate sixth-text-color">{info.data?.hotRequest ? "S" : "N"} </span> 
                                    </div> 
                                </div>
                            </div>
                        </form>
                    }
                />
            </div>
            <ul className="collection col s12" >
                {data.map((item, index) => (
                    renderItem(item, index)
                ))}
            </ul>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        filter: state.physicalConfirmationReducer.filter,
        docks: state.configReducer.docks,
        sheds: state.configReducer.shedsUnload
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPartNumbers: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getReceiptsPartNumber(filter, callback));
        },
        createConfirmation: (receiptItem, quantity, mdrType) => {
            dispatch(PhysicalConfirmationService.createConfirmation(receiptItem, quantity, mdrType));
        },
        setFilter: (filter) => {
            dispatch(PhysicalConfirmationService.setFilter(filter));
        },
        setShed: (shed) => {
            dispatch(SecurityService.setShed(shed));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SearchPartNumber));